export default __webpack_public_path__ + "static/media/mario.e9586603.jpg";